import { GetTransactionsFilters } from '@/types/getTransactionsFilters';

const COUNTABLE_KEYS = new Set<string>([
  'id',
  'type',
  'status',
  'fromDate',
  'toDate',
  'amount',
  'currency',
  'recipientId',
  'beneficiaryId',
  'awaitingFunding',
]);

export const countTransactionFilters = (
  filters: Partial<GetTransactionsFilters>,
  defaults: Partial<GetTransactionsFilters> = GetTransactionsFilters.initial(),
): number =>
  Object.entries(filters).reduce(
    (totalCount: number, [key, value]: [string, unknown]): number =>
      COUNTABLE_KEYS.has(key) && value !== defaults[key as keyof GetTransactionsFilters]
        ? totalCount + 1
        : totalCount,
    0,
  );
